export const AttachmentTR={
AttaID:{en:'AttaID',cs:'AttaID',dataType:'number',format:'#0',required:true},
AttaTableID:{en:'AttaTableID',cs:'AttaTableID',dataType:'number',format:'#0',required:true},
AttaRecordID:{en:'AttaRecordID',cs:'AttaRecordID',dataType:'number',format:'#0',required:true},
AttaOriginalFileName:{en:'Attachment File',cs:'',dataType:'string',required:true,maxLength:200},
AttaFileName:{en:'AttaFileName',cs:'AttaFileName',dataType:'string',required:true,maxLength:200},
AttaDateTime:{en:'Upload Date/Time',cs:'',dataType:'datetime',format:'dd.MM.yyyy HH:mm:ss',required:true},
AttaUserID:{en:'Uploaded By',cs:'',dataType:'number',format:'#0',required:true},
AttaTag:{en:'AttaTag',cs:'AttaTag',dataType:'string',maxLength:100},
AttaDescription:{en:'AttaDescription',cs:'AttaDescription',dataType:'string',maxLength:500},
AttaTimeStamp:{en:'AttaTimeStamp',cs:'AttaTimeStamp',dataType:'number',format:'#0'}
}